import React from 'react';
import Title from '../../title';
import $ from "jquery";
import Server from '../../../functions/server';
import Loading from '../../loading';
import { Grid, Button } from 'semantic-ui-react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import ReadCookie from '../../../functions/readcookies';
import './style.css';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Slide from '@material-ui/core/Slide';
import CloseIcon from '@material-ui/icons/Close';
import Dialog from '@material-ui/core/Dialog';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = { appBar: { position: 'relative', }, flex: { flex: 1, }, };

function Transition(props) { return <Slide direction="up" {...props} />; }

class FullScreenDialog extends React.Component {

  state = {
    openChitta: false, todayCash: 0, openingCredit: 0, openingCash: 0,
    chitta: [], fullWidth: true, maxWidth: 'xl', branchName: '', openingSales: 0, openingPurchase: 0
  }


  getChitta() {
    let context = this;
    let data = (ReadCookie("branch"));
    let cook = (ReadCookie("vaigai"));
    let branchId, branchName, cashMode;
    let userId = cook.id;
    for (var i = 0; i < data.length; i++) {
      branchId = data[i].branch_id;
      branchName = data[i].name;
      cashMode = data[i].cash_mode;
    }
    $.ajax({
      type: 'POST', data: { 'date': context.props.date, 'branchName': branchName, 'branchId': branchId, 'executiveId': userId, cashMode },
      url: Server() + 'Accountings/Chitta/Get.php',
      success: function(chitta) {
        let openingSales = 0;
        let openingCredit = 0;
        let openingPurchase = 0;
        let openingCash = 0;
        let todayCash = 0;
        let data = [];
        try {
          chitta = JSON.parse(chitta);
          chitta.map((c) => {
            openingSales = c.opening_sales;
            openingPurchase = c.opening_purchase;
            openingCredit = c.opening_credit;
            openingCash = c.opening_cash;
            todayCash = c.today_cash;
            data = c.data;
          })
          // chitta = context.seprateData(chitta);
          context.setState({ openChitta:true, chitta: data, branchName, openingSales, openingPurchase, openingCredit, openingCash, todayCash })
        } catch (error) {
          alert('Try Again!!!');
        }
      },
      error: function(e) {
        context.setState({ load: false });
      }
    });
  }

  seprateData(chitta) {
    let transferInData = [];
    let transferOutData = [];
    let mode = [];
    chitta.map((c) => {
      c.amount = this.convertIntoNumber(c.amount);
      let value = 0;
      if (c.type == 'Transfer IN' || c.type == 'Transfer OUT') {
        value = 2;
        mode.map((d) => {
          if (d.voucher == c.voucher) {
            value = 1;
          }
        })
      }
      if (value == 2) {
        mode.push({ voucher: c.voucher })
      }
    })
    let removeChettaTransferINANDOUT = [];
    chitta.map((c) => {
      if (c.type == 'Transfer OUT') {
        transferOutData.push(c);
      }
      if (c.type == 'Transfer IN') {
        transferInData.push(c);
      }
      if (c.type != 'Transfer OUT' && c.type != 'Transfer IN') {
        removeChettaTransferINANDOUT.push(c);
      }
    })
    

    let filtertransferOutData = this.removeDuplicateData(transferOutData, 'voucher');
    let filtertransferInData = this.removeDuplicateData(transferInData, 'voucher');



    filtertransferOutData.map((c) => {
      let amount = 0;
      chitta.map((v) => {
        let amt = this.convertIntoNumber(v.amount);
        if (c.voucher == v.voucher && v.type == 'Transfer OUT') {
          amount = amount + amt;
        }
      })
      c.amount = amount;
    })

    filtertransferInData.map((c) => {
      let amount = 0;
      chitta.map((v) => {
        let amt = this.convertIntoNumber(v.amount);
        if (c.voucher == v.voucher && v.type == 'Transfer IN') {
          amount = amount + amt;
        }
      })
      c.amount = amount;
    })

    mode.map((v) => {
      let amount = 0;
      filtertransferInData.map((c) => {
        if (c.voucher == v.voucher) {
          amount = amount + c.amount;
        }
      })
      v.transfer_in = amount;
      let amount1 = 0;
      filtertransferOutData.map((c) => {
        if (c.voucher == v.voucher) {
          amount1 = amount1 + c.amount;
        }
      })
      v.transfer_out = amount1;
    })

    mode.map((c) => {
      c.type = 'Transfer';
      removeChettaTransferINANDOUT.push(c);
    })
    
    return removeChettaTransferINANDOUT;
  }


  removeDuplicateData(originalArray, prop) {
    var newArray = [];
    var lookupObject  = {};
    for(var i in originalArray) {
       lookupObject[originalArray[i][prop]] = originalArray[i];
    }
    for(i in lookupObject) {
        newArray.push(lookupObject[i]);
    }
    return newArray;
}


  changeDateFormat = (date) => {
    let s = new Date(date).toLocaleString(undefined, {timeZone: 'Asia/Kolkata'});
    date = s.split(',')[0];
    let month = date.split('/')[0];
    let day = date.split('/')[1];
    let year = date.split('/')[2];
    if (month <= 9) {
      month = '0'+month;
    }
    if (day <= 9) {
      day = '0'+day;
    }
    let a = year+'-'+month+'-'+day;
  }

  convertIntoNumber(value) {
    try {
      value = Number(value);
    } catch (error) {
      value = 0;
    }
    return value;
  }

  makeIntoDecimal(value) {
    try {
      value = value.toFixed(2);
    } catch (error) {
      value = 0;
    }
    return value;
  }

  makeIntoDecimal1(value) {
    try {
      value = value.toFixed(2);
    } catch (error) {
      value = '';
    }
    return value;
  }


  render() {
    const { classes } = this.props;
    let sino = 1;
    let totalExpense = 0;
    let totalCreditSales = 0; let totalCashSales = 0; let totalPayment = 0; let totaltrIn = 0;
    let totalCreditPurchase = 0; let totalCashPurchase = 0; let totalReceipt = 0; let totaltrOut = 0;
    let { expense, creditSales, cashSales, payment, receipt, trIn, trOut, amount, creditPurchase, cashPurchase } = 0;
    let openingSales = this.convertIntoNumber(this.state.openingSales);
    let openingPurchase = this.convertIntoNumber(this.state.openingPurchase);
    let openingCredit = this.convertIntoNumber(this.state.openingCredit);
    let openingCash = this.convertIntoNumber(this.state.openingCash);
    let todayCash = this.convertIntoNumber(this.state.todayCash);
    return (
      <div>
        <center style={{color: 'blue', cursor: 'pointer'}} onClick={this.getChitta.bind(this)}>view</center>
        <Dialog fullScreen
          open={this.state.openChitta} onClose={ () => { this.setState({ openChitta: false }) }}
          TransitionComponent={Transition}>
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton color="inherit" onClick={ () => { this.setState({ openChitta: false }) }} aria-label="Close"> <CloseIcon />
              </IconButton>
              <Typography variant="h6" color="inherit" className={classes.flex}>{'Chitta'}</Typography>
            </Toolbar>
          </AppBar>
            <Loading load={this.state.load} message={this.state.message} />
            <div style={{margin: '8px'}}>
            <div style={{display: 'flex', width: '100%'}}>
                <div style={{width: '70%'}}>
                {"Date: "+this.props.date}
                </div>
                <div style={{width: '30%'}}>
                {"Branch: "+this.state.branchName}
                </div>
            </div>
            <table id="table" width="100%">
                <tr id="th">
                  <th>Sino</th>
                  <th>Voucher No.</th>
                  <th>Name</th>
                  <th style={{width: '7%'}}>Sales<br/>With<br/>Receipt</th>
                  <th style={{width: '7%'}}>Credit <br/>Sales</th>
                  <th style={{width: '7%'}}>Purchase<br/>With<br/>Payment</th>
                  <th style={{width: '7%'}}>Credit <br/>Purchase</th>
                  <th style={{width: '7%'}}>Receipt</th>
                  <th style={{width: '7%'}}>Payment</th>
                  <th style={{width: '7%'}}>Expense</th>
                  <th style={{width: '7%'}}>Tr In</th>
                  <th style={{width: '7%'}}>Tr Out</th>
                  <th>Ref No</th>
                </tr>
                { 
                this.state.chitta.map((c) => {
                    amount = this.convertIntoNumber(c.amount);
                    expense = '';
                    creditSales = '';
                    cashSales = '';
                    creditPurchase = '';
                    cashPurchase = '';
                    payment = '';
                    receipt = '';
                    trIn = '';
                    trOut = '';
                    if (c.type == 'Expense') {
                      expense = amount * -1;
                      totalExpense = totalExpense + (amount * -1);
                    }
                    if (c.type == 'Sales') {
                      if (amount < 0) {
                          cashSales = amount * -1;
                          totalCashSales = totalCashSales + (amount * -1);
                      }
                      else {
                          creditSales = amount;
                          totalCreditSales = totalCreditSales + amount;
                      }
                    }
                    if (c.type == 'Receipt') {
                      receipt = amount * -1;
                      if (c.status == 'Approved') {
                        totalReceipt = totalReceipt + (amount * -1);
                      }
                    }
                    if (c.type == 'Purchase') {
                      if (amount < 0) {
                          creditPurchase = amount * -1;
                          totalCreditPurchase = totalCreditPurchase + (amount * -1);
                      }
                      else {
                          cashPurchase = amount;
                          totalCashPurchase = totalCashPurchase + amount;
                      }
                    }
                    if (c.type == 'Payment') {
                      payment = amount;
                      totalPayment = totalPayment + amount;
                    }
                    if (c.type == 'Transfer IN') {
                      trIn = amount;
                      totaltrIn = totaltrIn + trIn;
                    }
                    if (c.type == 'Transfer OUT') {
                      trOut = amount;
                      totaltrOut = totaltrOut + trOut;
                    }
                    return (
                    <tr style={{color: c.type == 'Receipt' ? c.status == 'Approved' ? 'black' : 'red' : 'black'}}>
                        <td>{sino++}</td>
                        <td>{c.voucher}</td>
                        <td>{c.name}</td>
                        <td><div style={{textAlign: 'right'}}>{this.makeIntoDecimal1(cashSales)}</div></td>
                        <td><div style={{textAlign: 'right'}}>{this.makeIntoDecimal1(creditSales)}</div></td>
                        <td><div style={{textAlign: 'right'}}>{this.makeIntoDecimal1(cashPurchase)}</div></td>
                        <td><div style={{textAlign: 'right'}}>{this.makeIntoDecimal1(creditPurchase)}</div></td>
                        <td><div style={{textAlign: 'right'}}>{this.makeIntoDecimal1(receipt)}</div></td>
                        <td><div style={{textAlign: 'right'}}>{this.makeIntoDecimal1(payment)}</div></td>
                        <td><div style={{textAlign: 'right'}}>{this.makeIntoDecimal1(expense)}</div></td>
                        <td><div style={{textAlign: 'right'}}>{this.makeIntoDecimal1(trIn)}</div></td>
                        <td><div style={{textAlign: 'right'}}>{this.makeIntoDecimal1(trOut)}</div></td>
                        <td>{''}</td>
                    </tr>
                    )
                })
                }
                <tr>
                  <td colspan="3" style={{borderLeftColor: 'white', borderBottomColor: 'white'}}>
                      <div style={{textAlign: 'right', fontWeight: 'bold', fontSize: '16px', height: '35px', marginTop: '17px'}}>Total</div>
                  </td>
                  <td style={{height: '35px'}}>
                      <div style={{textAlign: 'right', fontWeight: 'bold'}}>{this.makeIntoDecimal1(totalCashSales)}</div>
                  </td>
                  <td style={{height: '35px'}}>
                      <div style={{textAlign: 'right', fontWeight: 'bold'}}>{this.makeIntoDecimal1(totalCreditSales)}</div>
                  </td>
                  <td style={{height: '35px'}}>
                      <div style={{textAlign: 'right', fontWeight: 'bold'}}>{this.makeIntoDecimal1(totalCashPurchase)}</div>
                  </td>
                  <td style={{height: '35px'}}>
                      <div style={{textAlign: 'right', fontWeight: 'bold'}}>{this.makeIntoDecimal1(totalCreditPurchase)}</div>
                  </td>
                  <td style={{height: '35px'}}>
                      <div style={{textAlign: 'right', fontWeight: 'bold'}}>{this.makeIntoDecimal1(totalReceipt)}</div>
                  </td>
                  <td style={{height: '35px'}}>
                      <div style={{textAlign: 'right', fontWeight: 'bold'}}>{this.makeIntoDecimal1(totalPayment)}</div>
                  </td>
                  <td style={{height: '35px'}}>
                      <div style={{textAlign: 'right', fontWeight: 'bold'}}>{this.makeIntoDecimal1(totalExpense)}</div>
                  </td>
                  <td style={{height: '35px'}}>
                      <div style={{textAlign: 'right', fontWeight: 'bold'}}>{this.makeIntoDecimal1(totaltrIn)}</div>
                  </td>
                  <td style={{height: '35px'}}>
                      <div style={{textAlign: 'right', fontWeight: 'bold'}}>{this.makeIntoDecimal1(totaltrOut)}</div>
                  </td>
                  <td style={{borderRightColor: 'white', borderBottomColor: 'white'}}></td>
                </tr>
                <tr>
                <td colspan="3" style={{borderLeftColor: 'white', borderBottomColor: 'white'}}></td>
                <td><div style={{fontStyle: '18px', fontWeight: 'bold'}}><center>A</center></div></td>
                <td><div style={{fontStyle: '18px', fontWeight: 'bold'}}><center>B</center></div></td>
                <td><div style={{fontStyle: '18px', fontWeight: 'bold'}}><center>C</center></div></td>
                <td><div style={{fontStyle: '18px', fontWeight: 'bold'}}><center>D</center></div></td>
                <td><div style={{fontStyle: '18px', fontWeight: 'bold'}}><center>E</center></div></td>
                <td><div style={{fontStyle: '18px', fontWeight: 'bold'}}><center>F</center></div></td>
                <td><div style={{fontStyle: '18px', fontWeight: 'bold'}}><center>G</center></div></td>
                <td><div style={{fontStyle: '18px', fontWeight: 'bold'}}><center>H</center></div></td>
                <td><div style={{fontStyle: '18px', fontWeight: 'bold'}}><center>I</center></div></td>
                <td style={{borderRightColor: 'white', borderBottomColor: 'white'}}></td>
                </tr>
            </table>
            <div id="bordercolor">
                <table id="table" width="100%">

                <tr>
                    <td id="borderColor1"><div>Opening Cash</div></td>
                    <td id="borderColor2">{this.makeIntoDecimal1(openingCash)}</td>
                    <td id="borderColor1">Todays`s Cash</td>
                    <td id="borderColor2">{this.makeIntoDecimal(todayCash)}</td>
                    <td id="borderColor1">Closing Cash</td>
                    <td id="borderColor2">{this.makeIntoDecimal(openingCash + todayCash)}</td>
                </tr>


                <tr>
                    <td id="borderColor1">Opening Credit</td>
                    <td id="borderColor2">{this.makeIntoDecimal1(openingCredit)}</td>
                    <td id="borderColor1">Todays`s Credit<br/>(B - D)</td>
                    <td id="borderColor2">{this.makeIntoDecimal(totalCreditSales - totalCreditPurchase)}</td>
                    <td id="borderColor1">Closing Credit</td>
                    <td id="borderColor2">{this.makeIntoDecimal1(openingCredit + (totalCreditSales - totalCreditPurchase))}</td>
                </tr>

                <tr>
                    <td id="borderColor1">Opening Sales</td>
                    <td id="borderColor2">{this.makeIntoDecimal1(openingSales)}</td>
                    <td id="borderColor1">Todays`s Sales<br/>(A + B)</td>
                    <td id="borderColor2">{this.makeIntoDecimal(totalCashSales + totalCreditSales)}</td>
                    <td id="borderColor1">Closing Sales</td>
                    <td id="borderColor2">{this.makeIntoDecimal(openingSales + totalCashSales + totalCreditSales)}</td>
                </tr>


                <tr>
                    <td id="borderColor1">Opening Purchase</td>
                    <td id="borderColor2">{this.makeIntoDecimal1(openingPurchase)}</td>
                    <td id="borderColor1">Todays`s Purchase<br/>(C + D)</td>
                    <td id="borderColor2">{this.makeIntoDecimal(totalCashPurchase + totalCreditPurchase)}</td>
                    <td id="borderColor1">Closing Purchase</td>
                    <td id="borderColor2">{this.makeIntoDecimal(openingPurchase + totalCashPurchase + totalCreditPurchase)}</td>
                </tr>


                <tr>
                    <td id="borderColor1">Opening Suspense</td>
                    <td id="borderColor2"></td>
                    <td id="borderColor1">Todays`s Suspense</td>
                    <td id="borderColor2"></td>
                    <td id="borderColor1">Closing Suspense</td>
                    <td id="borderColor2"></td>
                </tr>


                </table>
                
            </div>
                
            </div>
        </Dialog>
      </div>
    );
  }
}

FullScreenDialog.propTypes = { classes: PropTypes.object.isRequired, };

export default withStyles(styles)(FullScreenDialog);